import {
  GET_SIK_ORDER,
  GET_SIK_ORDER_SUCCESS,
  GET_SIK_ORDER_FAILURE,
} from '../actions/sik';

const INITIAL_STATE = { status: 'LOADING', requested: false };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_SIK_ORDER:
      return {
        ...state,
        status: 'LOADING',
        requested: true,
      };
    case GET_SIK_ORDER_SUCCESS:
      return {
        ...state,
        status: 'READY',
        sikOrder: (action.payload && action.payload.sikOrder) || {},
      };
    case GET_SIK_ORDER_FAILURE:
      return {
        ...state,
        status: 'ERROR',
        error: action.payload,
      };
    default:
      return state;
  }
}
